import { GlobalSettingsControl } from "@/components/common/GlobalSettingsControl";
import { HaulerRouteList } from "./HaulerRouteList";
import { useHaulerApp } from "./useHaulerApp";

export function HaulerAppShell() {
  const app = useHaulerApp();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur dark:border-slate-800 dark:bg-slate-900/95">
        <div className="mx-auto flex max-w-2xl items-center justify-between gap-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-amber-700 dark:text-amber-400">
              Hauler portal
            </p>
            <h1 className="text-lg font-bold leading-tight">
              {app.payload?.carrier_name ?? "Assigned routes"}
            </h1>
            <p className="text-xs text-slate-500">View-only · your carrier scope</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => void app.refresh()}
              disabled={app.loading}
              className="rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-semibold disabled:opacity-50 dark:border-slate-600"
            >
              {app.loading ? "Loading…" : "Refresh"}
            </button>
            <GlobalSettingsControl />
          </div>
        </div>
        {app.isPlatform ? (
          <div className="mx-auto mt-3 flex max-w-2xl gap-2">
            <input
              type="text"
              value={app.carrierScopeInput}
              onChange={(e) => app.setCarrierScopeInput(e.target.value)}
              placeholder="Platform: carrier_id (UUID)"
              className="flex-1 rounded-lg border border-slate-300 px-3 py-1.5 text-xs dark:border-slate-600 dark:bg-slate-900"
            />
            <button
              type="button"
              className="rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white dark:bg-slate-100 dark:text-slate-900"
              onClick={() => void app.refresh()}
            >
              Apply
            </button>
          </div>
        ) : null}
        {app.error ? (
          <p className="mx-auto mt-2 max-w-2xl text-xs text-rose-700 dark:text-rose-300">{app.error}</p>
        ) : null}
      </header>

      <main className="mx-auto max-w-2xl px-4 py-4 pb-10">
        {app.loading ? (
          <p className="text-sm text-slate-600">Loading routes…</p>
        ) : app.payload ? (
          <HaulerRouteList carrierName={app.payload.carrier_name} routes={app.payload.routes} />
        ) : (
          <p className="text-sm text-slate-600">No route data available.</p>
        )}
      </main>
    </div>
  );
}
